import React, { useLayoutEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { IoChevronBack } from "react-icons/io5";

// Custom components
import HomePageSkeleton from "../../../components/skeletonLoading/HomePageSkeleton";
import { NotFound } from "../../error/NotFound_404";

// Custom hooks & API
import { useNavbar } from "../../../context/NavBarContext";
import { useFetchAudiobookBySeriesDataQuery } from "../../../api/audioBookBySeriesPageApi";
import BookBySeriesOld from "../../../components/audio/book-by-series/BookBySeriesOld";

const Index = () => {
  const Navbar = useNavbar();
  const { item_id: series_id } = useParams();


  // Setup back button icon
  useLayoutEffect(() => {
    Navbar.setTogglePlace(<IoChevronBack fontSize="20" />);
  }, []);

  // Fetch book/series data
  const {
    data,
    error,
    isLoading,
    isFetching,
  } = useFetchAudiobookBySeriesDataQuery(series_id, {
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false,
    refetchOnReconnect: false,
  });

  // Extract book data safely
  const bookData = useMemo(() => {
    if (!data) return null;
    return data.result || data.data || data;
  }, [data]);

  // Handle loading states
  if (isLoading || (isFetching && !bookData)) {
    return <HomePageSkeleton />;
  }

  if (error) {
    return <NotFound error={error} />;
  }

  if (!bookData) {
    return <HomePageSkeleton />;
  }

  return (
    <>
      <BookBySeriesOld bookData={bookData} />
    </>
  );
};

export default Index;
